import React from 'react';
import Button from 'components/Button';

import Modal from 'antd/lib/modal/Modal';
import DF from 'DisplayFramework';
import { ParMarketingResponse } from 'services/assetconfig';
import MarketingCompaignDetail from './MarketingDetails';

type MarketingModalProps = {
  onCancel?: () => void;
  visible?: boolean;
  onSelect: (mcomp: ParMarketingResponse) => void;
  mcid: number;
  onSuccess?: () => void;
};

const MarketingModal = ({
  visible,
  onCancel,
  onSelect,
  mcid,
}: MarketingModalProps) => {
  return (
    <DF.Provider pagcode="mcList">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1200}
        title="Modal List Modal"
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <MarketingCompaignDetail visible={false} mcid={mcid} />
      </Modal>
    </DF.Provider>
  );
};

export default MarketingModal;
